import gsap from "gsap";

export const animateRightHallChange = (
  camera: THREE.Camera,
  cb: any = undefined
) => {
  const tl = gsap.timeline({
    onComplete: () => {
      if (!cb) return;
      cb();
    },
  });
  tl.to(camera.position, {
    z: 103,
    duration: 0.3,
  });
  tl.to(
    camera.position,
    {
      x: 10,
      duration: 0.6,
    },
    0.6
  );
  tl.to(
    ".black-bg-banner",
    {
      opacity: 1,
      duration: 0.6,
      onComplete: () => {
        camera.position.z = 102;
        camera.position.x = 0;
      },
    },
    0.6
  );
};
export const animateLeftHallChange = (
  camera: THREE.Camera,
  cb: any = undefined
) => {
  const tl = gsap.timeline({
    onComplete: () => {
      if (!cb) return;
      cb();
    },
  });
  tl.to(camera.position, {
    z: 103,
    duration: 0.3,
  });
  tl.to(
    camera.position,
    {
      x: -10,
      duration: 0.6,
    },
    0.6
  );
  tl.to(
    ".black-bg-banner",
    {
      opacity: 1,
      duration: 0.6,
      onComplete: () => {
        camera.position.z = 102;
        camera.position.x = 0;
      },
    },
    0.6
  );
};
